// Support-/Service-Accounts (Praefix `itsce.`, IT-SCE-Staff ueber alle Tenants) tragen in
// Keycloak die Kunden-Domain im Username/in der E-Mail (itsce.name@kunde.de). Die Adresse
// existiert nicht als Postfach, sie dient nur dem Login. Angezeigt wird deshalb nur der
// Accountname. Reine Anzeige: Login, Keycloak-Daten und Owner-Abgleiche bleiben unberuehrt.

export interface IdentityLike {
  email?: string | null
  username?: string | null
  account_type?: string | null
}

const STAFF_PREFIX = 'itsce.'

function localPart(s: string | null | undefined): string {
  const v = (s ?? '').trim()
  const i = v.indexOf('@')
  return i >= 0 ? v.slice(0, i) : v
}

export function isItsceServiceAccount(m: IdentityLike | null | undefined): boolean {
  if (!m) return false
  return (
    localPart(m.username).toLowerCase().startsWith(STAFF_PREFIX) ||
    localPart(m.email).toLowerCase().startsWith(STAFF_PREFIX)
  )
}

/** Anzeige-Identitaet: bei itsce.-Accounts nur der Accountname, sonst die E-Mail. */
export function displayIdentity(m: IdentityLike | null | undefined): string {
  if (!m) return ''
  if (isItsceServiceAccount(m)) {
    return localPart(m.username).toLowerCase().startsWith(STAFF_PREFIX)
      ? localPart(m.username)
      : localPart(m.email)
  }
  return m.email ?? ''
}
